import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import React from "react";
import ReactDOM from "react-dom";
import Swal from "sweetalert2";
import config from "../../config";
import { headers } from "../../token";
import validateError from "../../ValidateError";
import vAdminformat from "../../adminFormat";

const server_backend = config.API_URL;

const generateQRCodeImage = async (value) => {
    return new Promise((resolve) => {
        const qrContainer = document.createElement('div');
        qrContainer.style.position = 'absolute';
        qrContainer.style.top = '0';
        qrContainer.style.left = '0';
        document.body.appendChild(qrContainer);

        ReactDOM.render(<QRCode value={value} size={100} />, qrContainer);

        setTimeout(async () => {
            const canvas = await html2canvas(qrContainer);
            const imgData = canvas.toDataURL('image/png');
            document.body.removeChild(qrContainer);
            resolve(imgData);
        }, 1000);
    });
};
const server_frontend = config.FrondEndURL;

const downloadOrderPDF = async (orderID) => {
    try {
        const response = await axios.get(`${server_backend}/orders/select?id=${orderID}`, headers);
        const data = response.data.RES_RESULT;

        if (response.data.RES_CODE === "00") {
            const qrCodeImageURL = await generateQRCodeImage(`${server_frontend}/orders/qr-group?trs=1&qr=${data.qrcode}`);
            
            setTimeout(async () => {
                const input = document.createElement('div');
                input.id = 'printable-area';
                input.style.width = '700px';
                input.style.padding = '20px';

                input.innerHTML = `
                <div class="container mt-4 p-4" style="max-width: 800px;">
                   
                        <!-- Primera Columna -->
                        <div class="col-12">
                            <div class="card h-100 d-flex justify-content-center align-items-center text-center">
                              
                                <div class="card-body">
                                    ${qrCodeImageURL ? `
                                        <img src="${qrCodeImageURL}" alt="QR Code" style="max-width: 150px;" />
                                        <h6 class="mt-3">Collective QR</h6>
                                    ` : '<p>Loading QR Code...</p>'}
                                </div>
                            </div>
                        </div>

                        <!-- Segunda Columna -->
                        <div class="col-12">
                            <div class="card h-100">
                                <div class="card-body">
                                    <table class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <td class="font-weight-bold">Name:</td>
                                                <td>${data.fullname || "Full Name"}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold">Order No.:</td>
                                                <td>${data.ord_ID || "Order ID"}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold">Date:</td>
                                                <td>${vAdminformat.FormatDate(data.date_created) || "Date Created"}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold">Components:</td>
                                                <td>${data.materials_name || "Materials"}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold">Parts:</td>
                                                <td>${data.parts || "Parts"}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <h6 class="mt-4">Job Details:</h6>
                                    <table class="table table-bordered table-sm">
                                        <tbody>
                                            ${data.jobs.map((item) => `
                                                <tr>
                                                    <td>${item.comment || "Comment"}</td>
                                                    <td>${item.materials_name || "Material"}</td>
                                                    <td>X${item.qty || 0}</td>
                                                </tr>
                                            `).join('')}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
            
                </div>
            `;

                document.body.appendChild(input);

                const canvas = await html2canvas(input, { scale: 2, backgroundColor: null });
                const imgData = canvas.toDataURL('image/jpg');
                const pdf = new jsPDF('p', 'mm', 'a4');

                const pdfWidth = 210;
                const pdfHeight = 297;
                const margin = 0;
                const imgWidth = canvas.width / 2;
                const imgHeight = canvas.height / 2;
                const scaleFactor = Math.min((pdfWidth - margin * 2) / imgWidth, (pdfHeight - margin * 2) / imgHeight);
                const finalWidth = imgWidth * scaleFactor;
                const finalHeight = imgHeight * scaleFactor;
                const xOffset = (pdfWidth - finalWidth) / 2;
                const yOffset = (pdfHeight - finalHeight) / 2;

                pdf.addImage(imgData, 'JPG', xOffset, yOffset, finalWidth, finalHeight);
                pdf.save(`${data.fullname + " | " + vAdminformat.FormatDate(data.date_created)}.pdf`);

                document.body.removeChild(input);
            }, 1000);
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'An unexpected error has occurred. Please try again later.',
            });
        }
    } catch (error) {
        validateError(error);
    }
};

export default downloadOrderPDF;
